var winScrollTop=0;

$.fn.is_on_screen = function(){
	var win = $(window);
	var viewport = {
		top : win.scrollTop(),
		left : win.scrollLeft()
	};
	viewport.bottom = viewport.top + win.height();

	var bounds = this.offset();
	bounds.bottom = bounds.top + this.outerHeight();

	return (!(viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};

function parallax() {
	$('.dekoration .box').each(function(){

		var firstTop = $(this).closest('.dekoration').offset().top;
		var moveTop = (firstTop-winScrollTop)*($(this).attr('speed')/10);
		$(this).css('transform','translateY('+-moveTop+'px)');

	});
}

$(window).scroll(function(e){
	winScrollTop = $(this).scrollTop();
	parallax();
});

$( document ).ready(function() {
	winScrollTop = $(this).scrollTop();
	parallax();
});


